<script setup lang="ts">
import { useConfirm } from '@/composables/useConfirm'
import BaseModal from './BaseModal.vue'

const { state, settle } = useConfirm()
</script>

<template>
  <BaseModal
    :open="state.visible"
    :title="state.title"
    :danger="state.danger"
    :ok-text="state.okText"
    :cancel-text="state.cancelText"
    @update:open="(v) => !v && settle(false)"
    @ok="settle(true)"
  >
    {{ state.text }}
  </BaseModal>
</template>
